<template>
  <div v-parallax-fit="parallax" class="sheet">
    <img src="/themes/rise-theme/dist/images/estate/character-view/holly/16_RentLetter.png" alt="">
  </div>
</template>

<script>
export default {
  data() {
    return {
      mutationObserver: null,
      parallax: [
        {
          start: 8500,
          end: 10500,
          fromStyle: { transform: 'translateY(-250%) rotateZ(10deg)', marginTop: '0px' },
          toStyle: { transform: 'translateY(0%) rotateZ(10deg)', marginTop: '10px' },
          easing: 'linear'
        },
        {
          start: 10550,
          end: 11500,
          fromStyle: { transform: 'translateY(0%) rotateZ(10deg)', marginTop: '0px' },
          toStyle: { transform: 'translateY(250%) rotateZ(10deg)', marginTop: '0px' },
          easing: 'linear'
        }
      ]
    }
  },
  mounted() {
    const self = this;
    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach(mutation => {
        if (mutation.target.style.marginTop == '10px') {
          self.$evidence.value = null;
          self.$readMore.value = '';
        }
      });
    });

    this.mutationObserver.observe(document.querySelector('.sheet'), {
      attributes: true,
      attributeFilter: ['style']
    });
  },
  unmounted() {
    this.mutationObserver.disconnect();
  }
}
</script>

<style lang="scss" scoped>
.sheet {
  position: absolute;
  bottom: -5%;
  right: 10%;
  z-index: 2;
  max-width: 570px;
  transition: all 0.1s linear;
}

@media screen and (max-width: 1600px) {
  .sheet {
    max-width: 450px;
  }
}

@media screen and (max-width: 1024px) {
  .sheet {
    max-width: 400px;
  }
}

@media screen and (max-width: 650px) {
  .sheet {
    max-width: 250px;
  }
}
</style>
